export const BLOG_CATEGORIES = [
  { slug: "ecobags", name: "Sacolas de Algodão Personalizadas", color: "#996515" },
  { slug: "brindes-corporativos", name: "Brindes Corporativos", color: "#996515" },
  { slug: "marketing-promocional", name: "Marketing Promocional", color: "#996515" },
  { slug: "eventos", name: "Eventos Corporativos", color: "#996515" },
  { slug: "sustentabilidade", name: "Sustentabilidade Empresarial", color: "#996515" },
  { slug: "branding", name: "Branding", color: "#996515" },
];

export const BLOG_POSTS = [
  {
    slug: "como-escolher-ecobag-personalizada-para-empresa",
    title: "Como escolher a sacola de algodão personalizada ideal para a sua empresa",
    excerpt:
      "Gramatura, cor, tipo de personalização e quantidade — um guia rápido para acertar na escolha da sua próxima ação com sacolas de algodão corporativas.",
    cover: "/legacy/ecobag-catalago-01.png",
    category: "ecobags",
    author: "Marcelo Naief",
    date: "2026-01-12",
    readTime: "6 min",
    keywords: "sacola de algodão personalizada, sacola de algodão corporativa, sacola personalizada, brinde sustentável",
    body: [
      "A sacola de algodão é hoje um dos brindes corporativos mais procurados — e por bons motivos. Ela é útil, reutilizável, sustentável e ainda funciona como uma mídia ambulante que carrega a sua marca por toda a cidade.",
      "**Comece pela gramatura do tecido.** Gramaturas mais baixas (80g) são econômicas, indicadas para eventos pontuais. Gramaturas mais altas (120g a 200g) deixam a sacola mais firme, durável e com cara de produto de qualidade — ideais para clientes que você quer impressionar.",
      "**Tamanho importa.** Para feiras e congressos, 30×40 cm é o padrão. Para kits de boas-vindas, 38×42 cm acomoda mais itens. Já para presentes maiores ou compras, 40×45 cm dá mais espaço.",
      "**Cor com propósito.** O cru natural transmite sustentabilidade. As coloridas (preto, azul, vermelho) destacam logos coloridos. Se a sua marca é forte em uma cor, vale tingir.",
      "**Personalização: silk-screen, transfer ou serigrafia digital?** Para tiragens grandes e poucas cores, silk-screen é o mais econômico. Para arte com fotos ou degradê, transfer ou serigrafia digital entregam melhor resultado.",
      "**Quantidade.** Nosso pedido mínimo começa em 50 unidades, mas o ponto de melhor custo-benefício costuma estar acima de 200 unidades. Para campanhas anuais, considere fazer um lote maior — o custo por peça cai bastante.",
      "Quer ver uma proposta pronta para a sua próxima ação? Fale com a gente pelo WhatsApp ou solicite um orçamento aqui mesmo no site. Em poucas horas você recebe uma proposta com prazo, valores e mockup digital.",
    ],
  },
  {
    slug: "brindes-corporativos-que-realmente-funcionam",
    title: "Brindes corporativos que realmente funcionam: 7 dicas práticas",
    excerpt:
      "Nem todo brinde gera lembrança. Conheça os critérios usados por empresas que acertam na hora de presentear clientes e colaboradores.",
    cover: "/legacy/squeeze-garrafa-de-al-minio-01.png",
    category: "brindes-corporativos",
    author: "Marcelo Naief",
    date: "2026-01-20",
    readTime: "5 min",
    keywords: "brindes corporativos, brindes para empresas, brindes promocionais, fornecedor de brindes",
    body: [
      "Brinde corporativo bom é aquele que o cliente usa. Se vai parar na gaveta, foi dinheiro jogado fora. Aqui vão 7 critérios para escolher bem.",
      "**1. Utilidade no dia a dia.** Squeeze, sacola de algodão, caderno, caneca: itens que entram na rotina geram mais lembrança que canetas plásticas genéricas.",
      "**2. Conexão com a marca.** Empresa de saúde combina com produtos sustentáveis. Empresa de tecnologia combina com gadgets. Faz sentido para o seu público?",
      "**3. Qualidade percebida.** Um brinde mal acabado prejudica a imagem da empresa. Materiais que duram e personalização bem feita falam por você.",
      "**4. Embalagem.** A primeira impressão é a embalagem. Considere caixinhas personalizadas ou cartões com mensagem.",
      "**5. Personalização inteligente.** Em vez de só estampar o logo gigante, pense em frases que conectam, datas comemorativas ou ilustrações exclusivas.",
      "**6. Quantidade certa.** Pedir muito acima do necessário gera estoque parado. Pedir pouco te deixa sem para o próximo evento.",
      "**7. Fornecedor parceiro.** Trabalhar com quem entende de brindes corporativos faz diferença — prazo, produção e arte são acompanhados de perto.",
      "A M NAIEF atende empresas em todo o Brasil com pedidos a partir de 50 unidades. Fale com a gente e a gente monta a melhor combinação para o seu objetivo.",
    ],
  },
  {
    slug: "kit-evento-corporativo-checklist",
    title: "Kit para evento corporativo: o checklist completo",
    excerpt:
      "Sacola, squeeze, bloquinho, caneta, identificação. Veja a lista que nossos clientes mais pedem para fechar um kit de evento bonito e funcional.",
    cover: "/legacy/cs-tnt-preta-01.png",
    category: "eventos",
    author: "Marcelo Naief",
    date: "2026-02-02",
    readTime: "4 min",
    keywords: "kit evento corporativo, brinde para evento, sacola TNT personalizada, evento empresarial",
    body: [
      "Organizando um evento corporativo? O kit do participante faz parte da experiência — e quando bem montado, vira material de marketing por meses.",
      "**Sacola.** A peça que carrega todo o resto. Sacolas TNT são econômicas e fechadas em poucos dias. Sacolas de algodão duram mais e têm melhor percepção.",
      "**Squeeze ou copo.** Hidratação é essencial em eventos. Squeezes personalizados resolvem o consumo de plástico e ainda viram lembrança após o evento.",
      "**Bloquinho e caneta.** Mesmo na era digital, anotar à mão ajuda. Capa personalizada com a marca, melhor ainda.",
      "**Crachá ou identificação.** Cordão de pescoço (lanyard) personalizado dá organização e profissionalismo ao evento.",
      "**Brinde-surpresa.** Um item extra ao final do dia (uma toalha de mão, um chaveiro, uma caixinha) é o detalhe que fideliza o participante.",
      "Quer montar o seu kit? A gente fecha tudo em um orçamento só — mais rápido e mais barato do que comprar item por item de fornecedores diferentes.",
    ],
  },
  {
    slug: "sustentabilidade-empresarial-com-brindes",
    title: "Sustentabilidade na prática: como brindes podem ajudar sua empresa",
    excerpt:
      "Pequenas escolhas que sua empresa pode fazer agora para reduzir descartáveis e fortalecer a comunicação ESG com clientes e colaboradores.",
    cover: "/legacy/salacola-home-pege.png",
    category: "sustentabilidade",
    author: "Marcelo Naief",
    date: "2026-02-08",
    readTime: "5 min",
    keywords: "brindes sustentáveis, sustentabilidade empresarial, ESG, brindes ecológicos, sacola de algodão",
    body: [
      "Sustentabilidade deixou de ser tendência e virou parte da estratégia. E os brindes corporativos são uma das formas mais visíveis de comunicar o compromisso da sua empresa.",
      "**Substitua o plástico.** Squeezes reutilizáveis no lugar de garrafas PET, sacolas de algodão no lugar de sacolas descartáveis. Uma única sacola de algodão pode substituir centenas de sacolas plásticas ao longo da vida útil.",
      "**Escolha materiais naturais.** Algodão cru, bambu, papel reciclado, juta. Materiais que voltam à natureza ao final da vida útil.",
      "**Pense na produção local.** Comprar de fornecedores próximos reduz a pegada de carbono do transporte e fortalece a economia local.",
      "**Conte a história.** Não basta usar o produto sustentável — comunique para o seu público. Uma etiqueta explicando que a sacola de algodão é feita de algodão cru reciclável já educa o cliente.",
      "Na M NAIEF trabalhamos majoritariamente com algodão, alumínio e materiais reutilizáveis. Se a sua empresa busca alinhar o ESG ao marketing, fale com a gente.",
    ],
  },
  {
    slug: "marketing-promocional-baixo-custo",
    title: "Marketing promocional de baixo custo que realmente funciona",
    excerpt:
      "Estratégias acessíveis para PMEs gerarem lembrança de marca e novos contatos — sem precisar de grandes orçamentos.",
    cover: "/legacy/toalha-de-m-o-01.png",
    category: "marketing-promocional",
    author: "Marcelo Naief",
    date: "2026-02-14",
    readTime: "4 min",
    keywords: "marketing promocional, marketing de baixo custo, brindes promocionais, ações promocionais",
    body: [
      "Quem disse que marketing precisa ser caro? Pequenas e médias empresas podem gerar grande impacto com poucos recursos — desde que sejam direcionados.",
      "**Brindes em parcerias.** Una sua marca a outra empresa complementar e dividam o investimento em sacolas personalizadas para clientes de ambas.",
      "**Sorteios nas redes sociais.** Um squeeze ou sacola de algodão personalizada como prêmio gera engajamento e mais seguidores.",
      "**Kit boas-vindas para novos clientes.** Quem é bem recebido vira fã. Um kit simples (sacola + caderno + caneta) custa pouco e fideliza muito.",
      "**Eventos pequenos e frequentes.** Em vez de um grande evento por ano, faça quatro pequenos — distribua brindes e mantenha sua marca presente.",
      "Tudo isso a partir de 50 unidades. Fale com a gente para fechar a sua próxima ação.",
    ],
  },
  {
    slug: "branding-pequenos-detalhes-grandes-resultados",
    title: "Branding: como pequenos detalhes constroem grandes marcas",
    excerpt:
      "Da escolha da cor à textura do material — entenda como os detalhes definem a percepção da sua marca pelo cliente.",
    cover: "/legacy/ecobag-catalago-01.png",
    category: "branding",
    author: "Marcelo Naief",
    date: "2026-02-20",
    readTime: "5 min",
    keywords: "branding, identidade visual, branding corporativo, gestão de marca",
    body: [
      "Branding é a soma de todos os pontos de contato da sua marca com o cliente. E muitos deles passam pelos brindes corporativos.",
      "**Consistência visual.** Use sempre as mesmas cores Pantone, a mesma tipografia e o mesmo logo. Um logo distorcido em uma sacola enfraquece todo o trabalho de marca.",
      "**Tato e textura.** A sensação física do produto comunica. Um material áspero passa rusticidade, um material liso passa modernidade. Escolha conforme o seu posicionamento.",
      "**Storytelling no brinde.** Uma frase, uma data, uma ilustração que conta a história da sua marca transforma um brinde comum em algo memorável.",
      "**Pequenas marcas em locais inesperados.** O logotipo no fundo da sacola, na alça interna, no fundo do squeeze. Detalhes que o cliente descobre depois e adora.",
      "Trabalhar com um fornecedor que entende de branding faz diferença. Mostre sua identidade visual e a gente ajuda a manter a coerência em cada peça.",
    ],
  },
];

export const getPostBySlug = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
export const getPostsByCategory = (cat) => BLOG_POSTS.filter((p) => p.category === cat);
